<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up com_pop" style="display: block">
        <div class="pop_tit _flex _bb">
            <p>배너</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>

        <div class="sign_form">
            <ul>
                <li class="file_wrap">
                    <span class="form_li_tit">PC 이미지</span>
                    <label for="area_banner_file">
                        <input id="area_banner_file" type="file" placeholder="" accept="image/*" multiple @change="handleFiles" />
                        <div class="file_box_wrap">이미지를 등록해주세요.</div>
                        <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                        <p class="p_info">PC 2000*777</p>
                    </label>

                    <div class="file_list with_btn">
                        <div class="file_img_pc">
                            <!-- <img style="max-width: 100%" :src="props.bannerInfo.file ? props.bannerInfo.file : 'img/main_slide.png'" alt="" /> -->
                            <img style="max-width: 100%" :src="state.fileUrl ? state.fileUrl : props.bannerInfo.file" alt="" />
                        </div>
                    </div>
                </li>
                <li class="file_wrap">
                    <span class="form_li_tit">모바일 이미지</span>
                    <label for="area_banner_file_mobile">
                        <input id="area_banner_file_mobile" type="file" placeholder="" accept="image/*" multiple @change="handleFilesForMobile" />
                        <div class="file_box_wrap">이미지를 등록해주세요.</div>
                        <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                        <p class="p_info">모바일 500*466</p>
                    </label>

                    <div class="file_list with_btn">
                        <div class="file_img_pc">
                            <img style="max-width: 100%" :src="state.fileMobileUrl ? state.fileMobileUrl : props.bannerInfo.fileMobile" alt="" />
                        </div>
                    </div>
                </li>
                <li>
                    <label for="title" class="form_li_tit">링크</label>
                    <input id="title" type="text" placeholder="링크를 입력해주세요" v-model="state.link" />
                </li>
            </ul>
            <div class="_flex _center btn_wrap">
                <button class="submit_btn _130 _gray" @click="closeModal">취소</button>
                <button class="submit_btn _130 _main_blue" @click="save">수정</button>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, CommonUtils, apiService, types, getMessageByCode } from "@/BaseComponent";

    export default {
        props: {
            bannerInfo: { type: Object },
        },
        emits: ["close", "save"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,

                fileUrl: "" as any,
                fileMobileUrl: "" as any,

                file: null as any,
                fileMobile: null as any,

                link: "" as string,
            });

            onMounted(() => {
                state.idx = props.bannerInfo.idx;

                state.link = props.bannerInfo.link;
                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            const closeModal = () => emit("close");

            const save = () => {
                let param = {
                    idx: state.idx,
                    link: state.link,
                    file: null,
                    fileMobile: null,
                };

                if (state.file) param.file = state.file;
                if (state.fileMobile) param.fileMobile = state.fileMobile;
                emit("save", param);
            };

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                const file = e.target.files[0];

                if (!file) return;

                if (!file.type.startsWith("image/")) {
                    e.target.value = "";
                    return;
                }

                let imgUrls = null;

                const reader = new FileReader();
                reader.onload = (ee: any) => {
                    imgUrls = ee.target.result;
                    state.fileUrl = imgUrls;
                    state.file = file;
                };
                reader.readAsDataURL(file);
                target.value = "";
            };

            const handleFilesForMobile = (e: any) => {
                const file = e.target.files[0];

                if (!file) return;

                if (!file.type.startsWith("image/")) {
                    e.target.value = "";
                    return;
                }

                let imgUrls = null;

                const reader = new FileReader();
                reader.onload = (ee: any) => {
                    imgUrls = ee.target.result;
                    state.fileMobileUrl = imgUrls;
                    state.fileMobile = file;
                }; // ref previewImage 값 변경
                reader.readAsDataURL(file);
            };

            return { state, closeModal, props, CommonUtils, save, handleFiles, handleFilesForMobile };
        },
    };
</script>
